import { Route, Switch } from "react-router-dom"
import TestStations from "./containers/TestStation"
import CustomersByRegion from "./containers/Customer"
import RegionAndDealers from "./containers/RegionAndDealers"
import AppUsers from "./containers/User"
import MotHistory from "./containers/MotHistory"
import DvsaTest from "./containers/DvsaTest"
import Schedules from "./containers/DVSASchedules"
import Vehicles from "./containers/Vehicles"
import Fees from "./containers/Fees"
import DvsaFees from "./containers/DvsaFees"
import CustomPrices from "./containers/CustomPrices"
import MotBooking from "./containers/MotBooking"
import Planner from "./containers/Planner"
import Overview from "./containers/Overview"
import FeesReport from "./containers/FeesReport"
import PassRateSummary from "./containers/PassRate/PassRateSummary"
import opportunities from "./containers/Activity/opportunity"
import Dashboard from "./containers/Dashboard"
import AccessPolicies from "./containers/AccessPolicies"
import { useAppSelector } from "./store"
import { RootState } from "./rootReducer"
import PassRateDetails from "./containers/PassRate/PassRateDetails"
import { appConfig } from "./Config"

const underConstructionPage = () => (
    <div style={{ height: "calc(100vh - 132px)", display: "flex", justifyContent: "center" }}>
        <div className="align-self-center mb-5 text-center">
            <h6 className="fs-1">Under development</h6>
            <p className="text-input sub-title">
                We are building this page,stay tuned. Soon this page will be functional.
            </p>
        </div>
    </div>
)

const notAllowedPage = () => (
    <div style={{ height: "calc(100vh - 132px)", display: "flex", justifyContent: "center" }}>
        <div className="align-self-center mb-5 text-center">
            <h1 className="fs-1">Not Allowed</h1>
            <p className="text-input sub-title">You are not allowed to access this Page</p>
        </div>
    </div>
)

const Routes = ({userInfoRoleId,}: { userInfoRoleId: any }) => {
    const roles = useAppSelector((state: RootState) => state.containers.users.roles)
    const AppUser = roles?.map(x => x.id) ?? []
    const AdminUser = [appConfig.globalAdminRoleId, appConfig.regionalAdminRoleId]

    const routesList = [
        {
            path: "/",
            component: Dashboard,
            permissions: AppUser,
        },
        {
            path: "/mot-bookings",
            component: MotBooking,
            permissions: AppUser,
        },
        {
            path: "/overview",
            component: Overview,
            permissions: AppUser,
        },
        {
            path: "/planner",
            component: Planner,
            permissions: AppUser,
        },
        {
            path: "/customers",
            component: CustomersByRegion,
            permissions: AppUser,
        },
        {
            path: "/test-stations",
            component: TestStations,
            permissions: AppUser,
        },
        {
            path: "/fees",
            component: Fees,
            permissions: AppUser,
        },
        {
            path: "/custom-prices",
            component: CustomPrices,
            permissions: AppUser,
        },
        {
            path: "/dvsa-fee",
            component: DvsaFees,
            permissions: AppUser,
        },
        {
            path: "/mot",
            component: MotHistory,
            permissions: AppUser,
        },
        {
            path: "/activities",
            component: opportunities,
            permissions: AppUser,
        },
        {
            path: "/users",
            component: AppUsers,
            permissions: AdminUser,
        },
        {
            path: "/regions-and-dealers",
            component: RegionAndDealers,
            permissions: AdminUser,
        },
        {
            path: "/dvsa-tests",
            component: DvsaTest,
            permissions: AppUser,
        },
        {
            path: "/dvsa-schedules",
            component: Schedules,
            permissions: AppUser,
        },
        {
            path: "/vehicles",
            component: Vehicles,
            permissions: AppUser,
        },
        {
            path: "/reports",
            component: FeesReport,
            permissions: AppUser,
        },
        {
            path: "/pass-rates-summary",
            component: PassRateSummary,
            permissions: AppUser,
        },
        {
            path: "/pass-rates-details",
            component: PassRateDetails,
            permissions: AppUser,
        },
        {
            path: "/access-policies",
            component: AccessPolicies,
            permissions: AdminUser,
        },
    ]

    const processRoutesList = (routes: any[], userRoleId: string) => routes.map(route => 
        <Route 
            key={route.path}
            path={route.path}
            exact
            component={route.permissions.some((routePermission: any) => userRoleId === routePermission) ? route.component : notAllowedPage} 
        />)

    return (
        <Switch>
            {processRoutesList(routesList, userInfoRoleId)}
            <Route component={underConstructionPage} />
        </Switch>
    )
}

export default Routes
